import { css } from 'linaria';
import { styled } from 'linaria/react';
import { ImgHTMLAttributes } from 'react';

export const ImgAvatar = styled.img<ImgHTMLAttributes<HTMLImageElement> & { color: string }>`
  --border-size: 1px;
  --avatar-size: var(--space-500);

  position: relative;
  top: calc(-2 * var(--border-size));
  left: calc(-2 * var(--border-size));
  width: calc(var(--avatar-size) + 4 * var(--border-size));
  height: calc(var(--avatar-size) + 4 * var(--border-size));

  &::after {
    position: absolute;
    top: var(--space-125);
    display: block;
    width: 100%;
    height: 100%;
    content: attr(data-placeholder);
  }

  &::before {
    content: '';
    position: absolute;
    width: var(--space-500);
    height: var(--space-500);
    inset: 0;
    background-color: ${(props) => props.color};
  }
`;

export const DivAvatar = styled.div`
  position: relative;
  width: var(--space-500);
  height: var(--space-500);
  overflow: hidden;
  font-size: 16px;
  text-align: center;
  border-radius: 50%;

  &::before {
    content: attr(data-placeholder);
    position: absolute;
    width: var(--space-500);
    height: var(--space-500);
    inset: var(--space-125) 0px 0px 0px;
  }
`;

export const avatarWrapper = css`
  display: flex;
`;
